import { SearchType } from '@aibees/elephant/types';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { EmptySearchResultAvatar } from '../search-bar/components/empty-search-result-avatar';
import { useEntitySearchData } from './hooks/use-entity-search-data';
import * as Styled from './styles';
import * as SX from './sx';
import type { EntitySearchHeaderProps as Props } from './types';

export const EntitySearchHeader = memo(({ className }: Props) => {
  const { type } = useEntitySearchData();

  return (
    <Styled.Wrapper
      className={classnames('EntitySearchHeader', className)}
      sx={SX.root}
      gap={4}
    >
      <Styled.LeftSideWrapper>
        <EmptySearchResultAvatar />
        {type === SearchType.Company && (
          <Typography variant="h5" fontWeight={700} color="grey.700">
            Find Your Company
            <Styled.Description variant="h5" fontWeight={700}>
              Lookalikes
            </Styled.Description>
            Here
          </Typography>
        )}
        {type === SearchType.People && (
          <Typography variant="h5" fontWeight={700} color="grey.700">
            👋🏻 Find Your B2B Contacts Here
          </Typography>
        )}

        <Typography variant="body3" fontWeight={400} color="grey.500">
          {type === SearchType.People
            ? 'Lookalike search is coming soon — for now, use filters for standard people search.'
            : 'Discover lookalike companies using input or use filters for standard search.'}
        </Typography>
      </Styled.LeftSideWrapper>
    </Styled.Wrapper>
  );
});

EntitySearchHeader.displayName = 'EntitySearchHeader';
